import { getRandomStr } from 'utils/common';
import Enums from 'utils/EnumsManager';

const { FieldTypes, ObjectTypes } = Enums;
const { TextInput } = FieldTypes;
const { Leads, Accounts, Opportunities } = ObjectTypes;

class BaseField {
  constructor(params) {
    // validations
    if (!_.isPlainObject(params)) {
      return console.error(
        'TypeError: params should be a proper object for BaseField!'
      );
    }

    const {
      id = -1,
      name = '',
      label = '',
      type = TextInput,
      modelType = Leads,
      isSystemField = false,
      restriction = false,
    } = params;

    // Notes: id is unique across all fields
    this.id = id;
    // Notes: field name is unique by type only
    this.name = name;
    this.label = label;
    // Field type, values from Enums
    this.type = type;
    this.modelType = modelType;
    this.isSystemField = isSystemField;
    // Object type, e.g. leads, accounts, opportunities
    this.objectType = this.parseModelTypeToObjectType(modelType);
    this.restriction = restriction;
  }

  // Used to parse arguments to expected value based on field type
  parseValue(val = '') {
    return val;
  }

  parseModelTypeToObjectType(modelType) {
    const str = modelType.replace('\\', '').toLowerCase();
    if (str.indexOf('lead') > -1) {
      return Leads;
    } else if (str.indexOf('account') > -1) {
      return Accounts;
    } else if (str.indexOf('opport') > -1) {
      return Opportunities;
    }
    return null;
  }

  getMockedValue() {
    return getRandomStr();
  }
}

export default BaseField;



// WEBPACK FOOTER //
// ./src/models/Fields/BaseField.js